export var ArticleFieldPath;
(function (ArticleFieldPath) {
    ArticleFieldPath["Category"] = "category";
    ArticleFieldPath["Section"] = "section";
    ArticleFieldPath["orderIndex"] = "orderIndex";
    ArticleFieldPath["deleted"] = "deleted";
})(ArticleFieldPath || (ArticleFieldPath = {}));
export var isArticle = function (doc) {
    return doc != null && doc.ref.parent.id.startsWith('article');
};
//# sourceMappingURL=article.js.map